var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98918 15.8776L8.36263 18.2166L6.07258 18.2651C5.3882 16.9957 5 15.5434 5 14C5 12.5076 5.36295 11.1002 6.00631 9.86098H6.0068L8.04559 10.2348L8.9387 12.2613C8.75177 12.8063 8.64989 13.3913 8.64989 14C8.64996 14.6606 8.76963 15.2936 8.98918 15.8776Z",
    fill: "#FBBB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8427 12.3187C22.9461 12.8631 23 13.4254 23 14C23 14.6444 22.9323 15.2729 22.8032 15.8791C22.3651 17.9422 21.2203 19.7437 19.6344 21.0185L19.6339 21.018L17.066 20.887L16.7025 18.6182C17.7548 18.0011 18.5772 17.0353 19.0104 15.8791H14.1979V12.3187H19.0806H22.8427Z",
    fill: "#518EF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6339 21.018L19.6344 21.0185C18.0921 22.2582 16.1328 23 14 23C10.5726 23 7.59272 21.0843 6.0726 18.2651L8.9892 15.8777C9.74924 17.9061 11.706 19.3501 14 19.3501C14.986 19.3501 15.9098 19.0835 16.7025 18.6182L19.6339 21.018Z",
    fill: "#28B446"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7446 7.07197L16.829 9.45894C16.0087 8.94615 15.0389 8.64992 14 8.64992C11.654 8.64992 9.66067 10.1601 8.9387 12.2613L6.00678 9.86098H6.00629C7.50415 6.97307 10.5216 5 14 5C16.1837 5 18.186 5.77787 19.7446 7.07197Z",
    fill: "#F14336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogle);
export default __webpack_public_path__ + "static/media/login-google.5e02bb1cf7f683813a93988539c2e721.svg";
export { ForwardRef as ReactComponent };